// extracted by mini-css-extract-plugin
export default {"pdf":"CV_pdf__m-+uw"};